<mat-dialog-content>
  <div class="card-width">
    <div class="ui grid">
      <div class="sixteen-wide-mobile fourteen-wide-computer column">
        <div class="image-cropper-container fade-in">
          <image-cropper
            class="fade-in"
            [imageURL]="imageList[this.currentIndex]"
            [maintainAspectRatio]="true"
            [aspectRatio]="imageOption.aspectRation"
            [resizeToHeight]="imageOption.resizeHeight"
            [resizeToWidth]="imageOption.resizeWidth"
            format="png"
            [autoCrop]="false"
            (imageLoaded)="imageLoaded()"
            [transform]="transform"
            #cropper
          ></image-cropper>

          <div class="ui inverted dimmer" [class.active]="isLoaded">
            <div class="ui indeterminate text loader">Preparing Files</div>
          </div>
        </div>
      </div>
      <div class="sixteen-wide-mobile two-wide-computer column pl-0">
        <div class="thumbnail-container">
          <div
            class="ui huge horizontal list w-90 thubnail-images"
            *ngIf="this.imageList.length != 0"
          >
            <div
              class="item"
              *ngFor="let image of imageList; let i = index"
              (click)="selectedImage(image, i)"
            >
              <img
                [src]="image"
                class="fade-in"
                [class.active-crop]="currentIndex === i"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="ui button" (click)="close()">Close</button>
  <button class="ui teal button" (click)="save()">Crop & Save</button>
</mat-dialog-actions>
